export default `
// STEP 1 - Enter the cookie name:
const cookieName = '';

// STEP 2 - Enter the cookie value:
const cookieValue = '';

// STEP 3 - Enter the number of days until the cookie expires:
const daysUntilExpiration = 365;



/////// PLEASE DO NOT MODIFY ANY CODE BELOW THIS LINE ///////



function setCookie(name, cookieValue, daysUntilExpiration) {
    const secondsUntilExpiration = daysUntilExpiration * 24 * 60 * 60;

    document.cookie = \`\${ cookieName }=\${ cookieValue };max-age=\${ secondsUntilExpiration }\`;
}

setCookie(cookieName, cookieValue, daysUntilExpiration);
`;
